export const initialState = {
    alert: {},
    requesting: false,
    activity: {},
    airlines: [],
    airports: [],
    user: {},
    headerTitle: ""
}